export default __webpack_public_path__ + "static/media/abandoned.213d68d0.svg";